// removed by extract-text-webpack-plugin
module.exports = {"container":"container_HomePage","layer":"layer_HomePage","row":"row_HomePage","leftBox":"leftBox_HomePage","section":"section_HomePage","headerBg":"headerBg_HomePage","img":"img_HomePage","set-img":"set-img_HomePage","setImg":"set-img_HomePage","cancle-img":"cancle-img_HomePage","cancleImg":"cancle-img_HomePage","alert":"alert_HomePage","rightBox":"rightBox_HomePage","title":"title_HomePage","beau-pic-wrap":"beau-pic-wrap_HomePage","beauPicWrap":"beau-pic-wrap_HomePage","h-title":"h-title_HomePage","hTitle":"h-title_HomePage"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePageStatic/HomePage.scss
// module id = 113
// module chunks = 0